export default function ToggleLine({label,description,toggledOn,checkRef,onChange}:{label:string,description:any,toggledOn:boolean,checkRef:React.RefObject<HTMLInputElement>|undefined,onChange:Function|undefined}){


    const onClikFunc = (e:any)=>{ //emulate a click on the checkbox
      let target = e.target as HTMLElement;
      if(target){
        let parent = target.closest(".wb-input-group")??target;
        let input = parent.querySelector("input");
        if(input && input.type=="checkbox"){
          input.click();
        }
      }
    
    }

    return (
        <div className="flex-row wb-input-group no-border max-100 align-start" style={{whiteSpace:"break-spaces"}}>
        <div className="check-box-holder" style={{ width: "68px", flexShrink: "0",position:"relative",cursor:"pointer" }}
        onClick={(e)=>onClikFunc(e)}
        >
          <input
            type="checkbox"
            ref={checkRef}
            defaultChecked={toggledOn}
            onChange={(e) => {onChange&&onChange(e.target.checked)}}
          />
          <span></span>
        </div>
        <div className="flex-column justify-start max-100">
          <label style={{cursor:"pointer"}} onClick={(e)=>onClikFunc(e)}>{label}</label>
          <div style={{ cursor:"pointer", color: "#777777", fontWeight: "400" }} onClick={onClikFunc}>
            {description}
          </div>
        </div>
      </div>
    )
}